import { MoreVert } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { useMenu } from '@prismamedia/one-components';
import { FC, useCallback, useMemo } from 'react';
import { SEE_ARTICLE_LABEL } from './constants';

interface ActionsMenuProps {
  publicUrl: string;
}

export const ActionsMenu: FC<ActionsMenuProps> = ({ publicUrl }) => {
  const { openMenu, closeMenu } = useMenu();

  const handleSeeArticle = useCallback(() => {
    if (publicUrl) {
      window.open(publicUrl);
      closeMenu();
    }
  }, [closeMenu, publicUrl]);

  const items = useMemo(
    () => [
      {
        value: SEE_ARTICLE_LABEL,
        onClick: handleSeeArticle,
      },
    ],
    [handleSeeArticle],
  );

  return (
    <IconButton
      arial-label="more"
      data-testid="menuBtn"
      onClick={(e) => {
        e.stopPropagation();

        openMenu(
          e.currentTarget,
          <div>
            {items.map((item, i) => (
              <MenuItem key={item.value + i} onClick={item.onClick}>
                {item.value}
              </MenuItem>
            ))}
          </div>,
        );
      }}
    >
      <MoreVert />
    </IconButton>
  );
};
